import { Button } from "@chakra-ui/react"
import Tooltip from "@pathwright/ui/src/components/tooltip/Tooltip"
import { useTranslate } from "@pathwright/ux/src/components/lng/useTranslate"
import Pathicon from "@pathwright/ux/src/components/pathicon/Pathicon"
import styled from "styled-components"
import {
  useCreateDiscussionSubscriptionMutation,
  useDeleteDiscussionSubscriptionMutation
} from "@pathwright/graphql-client/src/generated"
import { useDiscussionPerms } from "../../permissions"
import { getDiscussionContext } from "./utils"

const StyledTooltip = styled(Tooltip)`
  .Tooltip {
    min-width: 140px;
    white-space: normal;
    text-align: left;
  }
`

const DiscussionSubscription = ({ discussion }) => {
  const { t } = useTranslate()
  const discussionContext = getDiscussionContext(discussion)
  const discussionPerms = useDiscussionPerms(discussion)

  const [createDiscussionSubscription] =
    useCreateDiscussionSubscriptionMutation({
      variables: {
        context: discussionContext,
        discussion_id: discussion.id
      },
      optimisticResponse: {
        createDiscussionSubscription: {
          ...discussion,
          user_is_subscribed: true,
          __typename: "Discussion"
        }
      }
    })

  const [deleteDiscussionSubscription] =
    useDeleteDiscussionSubscriptionMutation({
      variables: {
        context: discussionContext,
        discussion_id: discussion.id
      },
      optimisticResponse: {
        deleteDiscussionSubscription: {
          ...discussion,
          user_is_subscribed: false,
          __typename: "Discussion"
        }
      }
    })

  const handleToggleSubscription = (e) => {
    e.stopPropagation()

    if (discussion.user_is_subscribed) return deleteDiscussionSubscription()
    if (discussionPerms.canSubscribeTo) return createDiscussionSubscription()
  }

  const tooltip = discussion.user_is_subscribed
    ? t("You'll be notified when someone replies to this post.")
    : t("Get notified when someone replies to this post.")
  const icon = discussion.user_is_subscribed ? "bell-fill" : "bell"

  return (
    <StyledTooltip title={tooltip}>
      <Button
        variant="ghost"
        onClick={handleToggleSubscription}
        colorPalette={discussion.user_is_subscribed ? "brand" : "blackAlpha"}
        disabled={!discussionPerms.canSubscribeTo}
        borderRadius="full"
        padding={1}
        gap={0}
      >
        <Pathicon icon={icon} />
      </Button>
    </StyledTooltip>
  )
}

DiscussionSubscription.displayName = "DiscussionSubscription"

export default DiscussionSubscription
